import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export default function PhotoLightbox({ src, alt, onClose }) {
  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80"
      onClick={onClose}>
      <button onClick={onClose} className="absolute top-4 end-4 text-white/70 hover:text-white p-2">
        <X size={24} />
      </button>
      <img src={src} alt={alt} className="max-w-[90vw] max-h-[90vh] object-contain rounded-xl"
        onClick={(e) => e.stopPropagation()} />
    </div>,
    document.body
  );
}
